import { useState } from "react";
import { useDispatch } from "react-redux";
import useInput from "../../hooks/userInput";
import { BsFillEnvelopeAtFill } from "react-icons/bs";
import { HiOutlineEnvelope, HiOutlinePaperAirplane } from "react-icons/hi2";

import cf from "../UI/ClassicForm.module.css";
import { alertActions } from "../../store/alert-slice";
import Spinner from "../UI/Spinner";
import { forgotPassword } from "../../api/api";

const ForgotPassword = () => {
  const dispatch = useDispatch();
  const [showSpinner, setShowSpinner] = useState(false);

  const {
    value: emailInput,
    enteredValueIsValid: emailInputIsValid,
    hasError: emailInputIsInvalid,
    valueInputChangedHandler: emailInputChangedHandler,
    valueInputBlurHandler: emailInputBlurHandler,
    reset: emailInputReset,
  } = useInput((value) => value.trim().includes("@"));

  let formIsValid = false;
  if (emailInputIsValid) {
    formIsValid = true;
  }

  const submitHandler = async (e) => {
    e.preventDefault();
    setShowSpinner(true);

    const res = await forgotPassword({ email: emailInput });

    if (res.status === "success") {
      dispatch(
        alertActions.setState({ message: res.message, status: res.status })
      );
    } else {
      dispatch(
        alertActions.setState({ message: res.message, status: "error" })
      );
    }

    setShowSpinner(false);

    emailInputReset();
    setTimeout(() => {
      dispatch(alertActions.resetState());
    }, 3000);
  };

  const emailInputClasses = emailInputIsInvalid
    ? `${cf.field} ${cf.invalid}`
    : cf.field;

  return (
    <form className={cf.form} onSubmit={submitHandler}>
      {showSpinner && <Spinner />}
      <div className={cf.formTitleRow}>
        <HiOutlineEnvelope className={cf.formTitleIcon} aria-hidden />
        <h2 className={cf.formTitle}>Reset your password</h2>
      </div>
      <p className={cf.formSubtitle}>
        Enter your email address and we will send you a link to proceed.
      </p>
      <div className={emailInputClasses}>
        <label htmlFor="forgot-email">Email address</label>
        <div className={cf.inputGroup}>
          <BsFillEnvelopeAtFill className={cf.icon} />
          <input
            id="forgot-email"
            type="email"
            autoComplete="email"
            value={emailInput}
            onChange={emailInputChangedHandler}
            onBlur={emailInputBlurHandler}
          />
        </div>
        {emailInputIsInvalid && (
          <span className={cf.fieldError}>Please enter a valid email.</span>
        )}
      </div>
      <div className={cf.actions}>
        <button type="submit" disabled={!formIsValid}>
          <HiOutlinePaperAirplane className={cf.btnIcon} aria-hidden />
          Proceed
        </button>
      </div>
    </form>
  );
};

export default ForgotPassword;
